import { useEffect } from 'react';

import history from 'src/history';
import { getElectronAPI } from 'src/hooks/useElectron';

/**
 * Hook to handle deep link navigation in the Electron app.
 * Listens for deep-link:navigate IPC events and pushes the path
 * to the router history, avoiding a full page reload.
 *
 * Auth callbacks are handled in the main process via loadURL (not IPC),
 * so they never arrive here.
 */
export const useDeepLinkNavigation = () => {
  useEffect(() => {
    const electronAPI = getElectronAPI();
    if (!electronAPI?.onDeepLinkNavigation) return;

    return electronAPI.onDeepLinkNavigation((path) => {
      history.push(path);
    });
  }, []);
};
